export default __webpack_public_path__ + "static/media/AdBlue_can20.459f602d.svg";